/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const DesktopIcon = ({
  className,
  style: styleFromProps,
  color = '#938BB7',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      style={style}
      className={classNames(className)}
      onClick={onClick}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10131_130309)">
        <path
          d="M7.5304 14.668C7.68164 15.6241 7.6069 16.6893 7.26492 17.5835H5.87381C5.09777 17.5835 5.09777 18.7502 5.87381 18.7502H14.0428C14.8382 18.7502 14.8382 17.5835 14.0428 17.5835H12.6516C12.3116 16.6944 12.2379 15.6264 12.3896 14.668H7.5304Z"
          fill="url(#paint0_linear_10131_130309)"
        />
        <path
          d="M2.37276 1.25C1.40195 1.25 0.625031 2.03831 0.625031 2.99772V11.1667H19.2917V2.99772C19.2917 2.03831 18.5195 1.25 17.544 1.25H2.37276ZM0.625031 11.1678V11.7489C0.625031 12.7244 1.41335 13.5011 2.37276 13.5011H17.544C18.5034 13.5011 19.2917 12.7219 19.2917 11.7489V11.1678H0.625031Z"
          fill="url(#paint1_linear_10131_130309)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10131_130309"
          x1="19.25"
          y1="1.28906"
          x2="1.86405"
          y2="19.8341"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.119792" stopColor="#222222" />
          <stop offset="1" stopColor="#688FA5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10131_130309"
          x1="19.2502"
          y1="1.28889"
          x2="1.86422"
          y2="19.834"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.119792" stopColor="#222222" />
          <stop offset="1" stopColor="#688FA5" />
        </linearGradient>
        <clipPath id="clip0_10131_130309">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
